module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-form-field mdc-radio-container"
  }, [(_vm.leftLabel) ? _c('label', {
    staticClass: "typography--body-3 typography--color-secondary clickable",
    attrs: {
      "id": (_vm.id + "-left-label"),
      "for": _vm.id
    }
  }, [_vm._t("left-label")], 2) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "mdc-radio"
  }, [_c('input', {
    staticClass: "mdc-radio__native-control",
    attrs: {
      "id": _vm.id,
      "type": "radio"
    },
    domProps: {
      "checked": _vm.state
    },
    on: {
      "change": _vm.onChange
    }
  }), _vm._v(" "), _vm._m(0)]), _vm._v(" "), (!_vm.leftLabel) ? _c('label', {
    staticClass: "typography--body-3 typography--color-secondary clickable",
    attrs: {
      "id": (_vm.id + "-label"),
      "for": _vm.id
    }
  }, [_vm._t("label")], 2) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mdc-radio__background"
  }, [_c('div', {
    staticClass: "mdc-radio__outer-circle"
  }), _vm._v(" "), _c('div', {
    staticClass: "mdc-radio__inner-circle"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3e71bb09","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Radio.vue
// module id = 1569
// module chunks = 1